import { http } from 'services/http';
import { EXPENSES_GET_MANY } from 'api/query-keys.ts';
import type { TCreateExpenseReq, TEntityIdRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateExpense = () => {
  return useMutationBase<TEntityIdRes, unknown, TCreateExpenseReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TEntityIdRes>('/v1/expenses', variables);
      return res.data;
    },

    invalidateCallback: () => [[EXPENSES_GET_MANY]],
  });
};
